﻿import * as React from "react";
import { INotification, NotificationManager } from "../../Managers";
import { IActiveSectionProps } from "../../SmartToolsRoot";
import { IBaseSectionProps } from "./IBaseSectionProps";
import { NotificationViewer } from "../NotificationViewer/NotificationViewer";

export interface INotificationSectionState {
    notificationLevel: string;
    notifications: INotification[];
    yPos: number;
}

export class NotificationSection extends React.Component<
    IBaseSectionProps,
    INotificationSectionState
> {
    constructor(props: IBaseSectionProps) {
        super(props);

        // Set initial state.
        this.state = {
            notificationLevel: `Information`,
            notifications: NotificationManager.notifications,
            yPos: 0,
        };
    }

    componentDidMount(): void {
        this._calcYPos();
        window.addEventListener(`resize`, this._calcYPos);
        NotificationManager.registerUpdate(this._updateViewer);
    }

    componentWillUnmount(): void {
        window.removeEventListener(`resize`, this._calcYPos);
        NotificationManager.registerUpdate(null);
    }

    private _sectionRef: HTMLElement;

    private readonly _priorities: string[] = [
        `Information`,
        `Low`,
        `Medium`,
        `High`,
    ];

    private readonly _updateViewer = (): void => {
        let highestVal = 0;

        for (let i = 0; i < NotificationManager.notifications.length; i++) {
            const notification: INotification =
                NotificationManager.notifications[i];

            let val = 0;

            switch (notification.priority) {
                case `Information`:
                    val = 0;
                    break;
                case `Low`:
                    val = 1;
                    break;
                case `Normal`:
                    val = 2;
                    break;
                case `High`:
                    val = 3;
                    break;
                default:
                    break;
            }

            if (val > highestVal) {
                highestVal = val;
            }
        }

        this.setState({
            notificationLevel: this._priorities[highestVal],
            notifications: NotificationManager.notifications,
        });
    };

    private readonly _bindOnClick = (): void => {
        const activeProps: IActiveSectionProps = {
            moduleID: this.props.moduleID,
            sectionType: this.props.sectionType,
        };

        this.props.toggleSection(activeProps, this._activeSectionsComparer);
    };

    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.
    private _activeSectionsComparer(
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] {
        for (let i = 0; i < activeSections.length; i++) {
            const sectionType = activeSections[i].sectionType;

            if (
                sectionType === `MyProfile` ||
                sectionType === `ToolMenu` ||
                sectionType === `Notifications` ||
                sectionType === `ReleaseNotes` ||
                sectionType === `DataFeedStatus` ||
                sectionType === `EditProfile`
            ) {
                activeSections.splice(i, 1);
                i--;
            }
        }

        return activeSections;
    }

    private readonly _calcYPos = (): void => {
        if (this._sectionRef) {
            const yPos: number =
                this._sectionRef.getBoundingClientRect().bottom;

            this.setState({
                yPos,
            });
        }
    };

    render(): React.ReactElement {
        const isActiveCSS: string = this.props.isActive ? `selected` : ``;

        return (
            <React.Fragment>
                <div
                    className={`tab-section ${isActiveCSS}`}
                    onClick={this._bindOnClick}
                    ref={(r): HTMLElement => (this._sectionRef = r)}
                >
                    <img
                        alt={this.props.name}
                        src={`/Images/Icon?icon=${this.props.moduleID}&folder=Module`}
                    />
                    {this.state.notifications.length > 0 && (
                        <div
                            className={`section-counterball ${this.state.notificationLevel}`}
                        >
                            {this.state.notifications.length}
                        </div>
                    )}
                </div>
                <NotificationViewer
                    isVisible={this.props.isActive}
                    notifications={this.state.notifications}
                    yPos={this.state.yPos}
                />
            </React.Fragment>
        );
    }
}
